import styled from "styled-components/macro";
import { Input, Button, Row, Col, Form as AntForm, Checkbox, Tabs } from 'antd';

export const CustomInput = styled(Input)`
  border: none;
  box-shadow: none;
  background-color: #f0f0f0; 
  
  &:focus {
    border: none;
    box-shadow: none;
    background-color: #e0e0e0; 
  }
`;

export const MarkupMainContainer = styled.div`
  background-color: #fff;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  padding: 22px;

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;




export const FormColumn = styled(Col)`
    display: flex;
    align-items: center;
    label {
        font-family: 'Rubik';
        font-style: normal;
        font-size: 16px;
        font-weight: 400;
        color: #000;
    }
    input {
        :hover {
            border-color: #D9D9D9;
        }
        color: #3F4254;
        font-weight: 500;
        font-size: 14px;
        font-family: 'Rubik';
        font-style: normal;
       
        line-height: 27px !important;
    }
    &.submit {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
`


export const FormRow = styled(Row) `
    margin-bottom: 22px;
    &.last {
        margin-bottom: 8px;
    }
`


export const BottomContent = styled.div`
    display: flex;
    margin-bottom: 15px;
`


export const DetailRow = styled.div`
    display: flex;
   flex-direction: column;
    align-items: center;
    
    margin-bottom: 18px;
    &.create {
        margin-bottom: 25px;
    }
    &.individual-rate {
        width: 28%;
        margin-bottom: 0px;
    }
    &.align-start {
        align-items: flex-start;
    }
`

// export const LeftContent = styled.div`
//     /* border-right: 2px dotted #E4E6EF; */
//     width: 50%;
//     display: flex;
//     flex-direction: column;
//     /* align-items: center; */
//     justify-content: space-between;
//     padding: 20px 0px;
//     &.create {
//         border-right: none;
//         width: 100%;
//     }
// `


export const LeftContent = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    justify-content: space-between;
    padding: 20px 0px;
    
    &.create {
        border-right: none;
        width: 100%;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }

    @media (min-width: 769px) and (max-width: 1024px) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const RowValue = styled.span`
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    color: #3F4254;
    &.raw-width {
        width: 60%;
        display: inline-block;
        word-break: break-all;
    }
`

export const TitleDiv = styled.div`
    width: 100%;
    &.create-rate {
        width: 16%;
    }
    &.individual-rate {
        /* margin-right: 10px; */
    }
`

export const TitleRow = styled.span`
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    margin-left:13%;
    color: #B5B5C3;
    &.sub-head {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        color: #FCB614;
    }
`

export const TabItem = styled(Tabs)`
    border: none !important;
    div {
        &.ant-tabs-content-holder {
            border: none !important;
        }
        &.ant-tabs-nav {
            width: 250px !important;
            @media (max-width: 1312px) {
                width: 200px !important; /* change width for smaller screens */
            }
        }
    }

    & .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
        background: #fff !important;
    }
    
`